import { INTERNAL_EVENT_SECURITY_KEY } from '../constants';

export const isInternalEventSource = (
  value: unknown
): value is typeof INTERNAL_EVENT_SECURITY_KEY =>
  value === INTERNAL_EVENT_SECURITY_KEY;
